import React from 'react';

import { Box, ButtonGroup } from '@mui/material';

import { FORM_FIELD_TYPES, FormField } from '../../../components/form/form-field';
import SaveButton from '../../../components/form/save-button';

const WriteDelimitedForm = ({ form, onSubmit, onChange }) => {
  const { errors } = form.formState;
  const formControl = form.control;

  return (
    <Box
      component="form"
      onSubmit={form.handleSubmit(onSubmit)}
      onReset={form.reset}
      onChange={onChange}
    >
      <FormField
        controlId="writeDelimitedFormName"
        label="name"
        name="name"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter name"
        required
        error={errors.name?.message}
      />
      <FormField
        controlId="writeDelimitedFormType"
        label="type"
        name="type"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        disabled
        error={errors.type?.message}
      />
      <FormField
        controlId="writeDelimitedFormQuoteAllFields"
        label="quoteAllFields"
        name="properties.quoteAllFields"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.CHECKBOX}
      />
      <FormField
        controlId="writeDelimitedFormDelimiter"
        label="delimiter"
        name="properties.delimiter"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter delimiter (e.g., comma, tab)"
        error={errors.properties?.delimiter?.message}
      />
      <FormField
        controlId="writeDelimitedFormHeader"
        label="header"
        name="properties.header"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.CHECKBOX}
      />
      <ButtonGroup>
        <SaveButton />
      </ButtonGroup>
    </Box>
  );
};

export default WriteDelimitedForm;
